module.exports = __webpack_public_path__ + "static/vf_wtop3_core.312b5a3a.svg";